// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.accordion-container {
  border-radius: 5px;
  border: 2px solid #D1D3D4;
}

.accordion-body {
  border: none;
  background: #EDf0F1;
}
.accordion-body h4 {
  color: red;
}

.group-background {
  display: flex;
  justify-content: center;
  border-radius: 10px;
  background: #EDf0F1;
  padding: 20px;
}
.group-background .group-container {
  display: flex;
  flex-direction: column;
  width: 45%;
}
.group-background .group-container .flags-container {
  border: 1px solid red;
}
.group-background .group-container .label {
  color: #0669B3;
  margin-left: 10px;
  font-size: 16px;
  font-weight: 500;
}
.group-background .group-container .availableSelected-group {
  border-radius: 5px;
  background: white;
  padding-left: 30px;
  height: 400px;
  overflow: hidden;
}
.group-background .group-container .availableSelected-group .options-buttons {
  border-radius: 5px;
  border: none;
  background: white;
  height: 400px;
  width: 100%;
}
.group-background .middle {
  width: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.group-background .middle .add-remove-button-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 120px;
}
.group-background .selected-flags-container {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/AvailableAndSelectedOptions.scss","webpack://./src/styles/global/GlobalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;ECAI,kBDCsB;EACtB,yBAAA;AAUJ;;AAPA;EACI,YAAA;EACA,mBDWI;ACDR;AATI;EACI,UAAA;AAWR;;AAPA;EACI,aAAA;EACA,uBAAA;ECfA,mBDgBsB;EACtB,mBDCI;ECAJ,aAAA;AAUJ;AARI;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AAUR;AARQ;EACI,qBAAA;AAUZ;AARQ;EACI,cDDC;ECED,iBAAA;EACA,eAAA;EACA,gBAAA;AAUZ;AAPQ;ECnCJ,kBDoC8B;EACtB,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AASZ;AAPY;EC1CR,kBD2CkC;EACtB,YAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;AAShB;AAJI;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAMR;AAJQ;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAMZ;AAHI;EACI,gBAAA;AAKR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n$dashboard-blue: #0d6efd;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n// $DCSD-logo-green: #84ae30; // old - does not pass\n// $DCSD-logo-green: #94B741; // this is the color from district site (see kellys screen shot)\n$DCSD-logo-green: #577d00; // darker green but does pass in FF\n$text: #414042;\n$white: #EDEDED;\n$shadow: #818181;\n$shadow2: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey0b: #e8e8e8; // new grey color\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$accessibility-red: rgb(218, 18, 18);\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/GlobalMixins\";\n\n.accordion-container {\n    @include borderRadius(5px);\n    border: 2px solid $grey1;\n}\n\n.accordion-body {\n    border: none;\n    background: $grey0;\n    & h4 {\n        color: red;\n    }\n}\n\n.group-background {\n    display: flex;\n    justify-content: center;\n    @include borderRadius(10px);\n    background: $grey0;\n    padding: 20px;\n\n    .group-container {\n        display: flex;\n        flex-direction: column;\n        width: 45%;\n\n        .flags-container {\n            border: 1px solid red;\n        }\n        .label {\n            color: $pearl-blue;\n            margin-left: 10px;\n            font-size: 16px;\n            font-weight: 500\n        }\n\n        .availableSelected-group {\n            @include borderRadius(5px);\n            background: white;\n            padding-left: 30px;\n            height: 400px;\n            overflow: hidden;\n\n            .options-buttons {\n                @include borderRadius(5px);\n                border: none;\n                background: white;\n                height: 400px;\n                width: 100%;\n            }\n        }\n    }\n\n    .middle {\n        width: 10%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n\n        .add-remove-button-container {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            align-items: center;\n            height: 120px;\n        }\n    }\n    .selected-flags-container {\n        margin-top: 20px;\n    }\n}\n\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
